import React, { Component } from 'react';
import casesContract from '../modules/casesContract';

class CasesContractPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  componentDidMount() {
  }
  render() {
  	return (
	    <div id="page-casesContract">
        <casesContract.container caseId={this.props.match.params.caseId} />
	    </div>
	  )
  }
}

export default CasesContractPageComponent;
